import script from "./whr-home-story.vue?vue&type=script&setup=true&lang=js"
export * from "./whr-home-story.vue?vue&type=script&setup=true&lang=js"

import "./whr-home-story.vue?vue&type=style&index=0&id=89f943ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89f943ce"]])

export default __exports__